export function GetExtension(fileName) {
  if (fileName == null) return "";

  fileName = fileName.toLowerCase();
  var fileExt = fileName.split(".").pop();
  if (fileExt == fileName) return "";

  return fileExt;
}
